import styled from '../../../../styles/styledComponents/themeComponents';

export const FormItemStyle = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-form-item-label {
    font-size: 15px;
    font-weight: 500;
    height: auto;
    overflow: visible;

    label {
      color: rgba(0, 0, 0, 0.65);
      height: auto;

      &.ant-form-item-required:before {
        font-size: 16px;
      }
    }
  }
  .ant-form-item-control {
    &.has-error {
      .ant-input {
        border: none;
      }
      .ant-input-group-addon {
        border: none;
      }
      .amondz-input,
      .amondz-textArea {
        border: 1px solid #f5222d;
      }
    }
  }
`;

export const CountLabelStyle = styled.span<{ isVertical: boolean }>`
  display: inline-flex;
  flex-direction: ${({ isVertical }): string => (isVertical ? 'column' : 'row')};
  .length {
    color: #7950f2;
  }
`;
